import { useState, useEffect } from 'react';
import { apiService } from '../../../../services/apiService';
import { useTenant } from '../../../../contexts/TenantContext';

const ThrowballOfficials = () => {
  const { siteSettings } = useTenant();
  const [officials, setOfficials] = useState([]);
  const [loading, setLoading] = useState(true);

  // Static/Default data - shown when no dynamic data exists
  const staticOfficials = [
    {
      id: 1,
      name: 'Mr. Ashish Saxena',
      state: 'Madhya Pradesh',
      address: '06 Vardhman Parisar Kolar Road, Bhopal (M.P.) 562016',
      phone: '09826286613',
      email: 'sadhnaashish13@gmail.com',
      image: '/theme/assets/images/Ashish.jpg'
    },
    {
      id: 2,
      name: 'Mr. Sanjay Srivastava',
      state: 'Uttar Pradesh',
      address: '683 Colonelganj Allahabad, U.P. 211002',
      phone: '09335163067, 09455622857',
      email: 'rsrivastava31@yahoo.com',
      image: '/theme/assets/images/Sanjay-Srivastava.jpg'
    },
    {
      id: 3,
      name: 'Mr. Pratap Kumar',
      state: 'Karnataka',
      address: 'Bengaluru, Karnataka',
      phone: '09742484822',
      email: 'pratapthrowball@gmail.com',
      image: '/theme/assets/images/Pratap_Karnataka.jpg'
    },
    {
      id: 4,
      name: 'Mr. Lekhraj Singh',
      state: 'Uttar Pradesh',
      address: '192 Police Line Road Buland Shahar, U.P. 203001',
      phone: '09639152179',
      email: 'isscosk@gmail.com',
      image: '/theme/assets/images/lekhraj-singh.jpg'
    },
    {
      id: 5,
      name: 'Mr. Shakeel Ahmad Khan',
      state: 'Uttar Pradesh',
      address: 'Kanpur, Uttar Pradesh',
      phone: '07007522314',
      email: 'sef.shakeel@gmail.com',
      image: '/theme/assets/images/Shakeel.jpg'
    },
    {
      id: 6,
      name: 'Mr. Jashobanta Paramguru',
      state: 'Odisha State',
      address: "St. Xavier's High School, Khandagiri, Bhubaneswar-751030",
      phone: '09437285645',
      email: 'jparamguru@gmail.com',
      image: '/theme/assets/images/jashobanta_paramaguru.jpg'
    },
  ];

  useEffect(() => {
    fetchOfficials();
  }, []);

  const fetchOfficials = async () => {
    try {
      setLoading(true);
      const response = await apiService.get('/public/officials');

      if (response.data) {
        const data = response.data;
        if (data.success && data.data && data.data.length > 0) {
          // Map API data to expected format
          const mappedOfficials = data.data.map((official, index) => ({
            id: official.id,
            name: official.name,
            state: official.state || '',
            address: official.address || '',
            phone: official.phone || official.contact || '',
            email: official.email || '',
            image: official.photo || '/theme/assets/images/default-official.jpg'
          }));
          setOfficials(mappedOfficials);
        } else {
          setOfficials(staticOfficials);
        }
      } else {
        setOfficials(staticOfficials);
      }
    } catch (error) {
      console.error('Error fetching officials:', error);
      setOfficials(staticOfficials);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="tb-page-section tb-officials-section">
      <div className="tb-container">
        {/* Top Banner */}
        <div className="tb-page-banner">
          <img src={siteSettings?.page_banners?.officials || '/theme/assets/images/banner-3.jpg'} alt="Officials Banner" />
        </div>

        {/* Page Content */}
        <div className="tb-page-content" style={{ padding: '40px 20px' }}>
          <div className="tb-heading-top" style={{ textAlign: 'center', marginBottom: '40px' }}>
            <h1 className="tb-page-title" style={{
              fontSize: '36px',
              fontWeight: '700',
              color: '#333',
              textTransform: 'uppercase',
              letterSpacing: '2px',
              marginBottom: '15px'
            }}>OFFICIALS</h1>
            <span style={{
              display: 'inline-block',
              width: '60px',
              height: '4px',
              background: 'linear-gradient(90deg, #f39c12, #e74c3c)',
              borderRadius: '2px'
            }}></span>
          </div>

          {loading ? (
            <div style={{ textAlign: 'center', padding: '2rem' }}>
              <p>Loading...</p>
            </div>
          ) : (
            <div className="tb-table-wrapper">
              <table className="tb-info-table" style={{
                width: '100%',
                borderCollapse: 'collapse',
                border: '1px solid #ddd'
              }}>
                <thead>
                  <tr>
                    <th style={{ background: '#3f75b1', color: '#fff', padding: '12px 10px', textAlign: 'center', border: '1px solid #ddd' }}>S. No.</th>
                    <th style={{ background: '#3f75b1', color: '#fff', padding: '12px 10px', textAlign: 'center', border: '1px solid #ddd' }}>Photos</th>
                    <th style={{ background: '#3f75b1', color: '#fff', padding: '12px 10px', textAlign: 'left', border: '1px solid #ddd' }}>Name</th>
                    <th style={{ background: '#3f75b1', color: '#fff', padding: '12px 10px', textAlign: 'left', border: '1px solid #ddd' }}>Address</th>
                    <th style={{ background: '#3f75b1', color: '#fff', padding: '12px 10px', textAlign: 'left', border: '1px solid #ddd' }}>Mobile numbers & E-mail</th>
                  </tr>
                </thead>
                <tbody>
                  {officials.map((official, index) => (
                    <tr key={official.id || index}>
                      <td style={{ padding: '15px 10px', textAlign: 'center', border: '1px solid #ddd', verticalAlign: 'middle' }}>{index + 1}</td>
                      <td style={{ padding: '15px 10px', textAlign: 'center', border: '1px solid #ddd', verticalAlign: 'middle' }}>
                        <img
                          src={official.image}
                          alt={official.name}
                          className="tb-official-photo"
                        />
                      </td>
                      <td style={{ padding: '15px 10px', border: '1px solid #ddd', verticalAlign: 'middle' }}>
                        {official.name}<br />
                        <small style={{ color: '#666' }}>({official.state})</small>
                      </td>
                      <td style={{ padding: '15px 10px', border: '1px solid #ddd', verticalAlign: 'middle', lineHeight: '1.5' }}>
                        {official.address}
                      </td>
                      <td style={{ padding: '15px 10px', border: '1px solid #ddd', verticalAlign: 'middle' }}>
                        {official.phone && (
                          <>
                            <a href={`tel:${official.phone.split(',')[0].trim()}`} style={{ color: '#3f75b1', textDecoration: 'none' }}>
                              {official.phone}
                            </a>
                            <br />
                          </>
                        )}
                        {official.email && (
                          <a href={`mailto:${official.email}`} style={{ color: '#3f75b1', textDecoration: 'none' }}>
                            {official.email}
                          </a>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ThrowballOfficials;
